export default {
  getHead: () => {
    return [{ name: '회사명' }, { name: '발생일시' }, { name: '재해자' }, { name: '상병명' }, { name: '처리상태' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).inputC_1 // 발생일시
      case 2: return func.onNameBlur(func.getContent(value).inputC_3) // 재해자
      case 3: return func.getContent(value).inputC_4 // 상병명
      case 4: return func.getContent(value).inputD_2 // 처리상태
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '발생일시': return ['content$body.inputC_1*%[:default_skw]%']
    case '재해자': return ['content$body.inputC_3*%[:default_skw]%']
    case '상병명': return ['content$body.inputC_4*%[:default_skw]%']
    case '처리상태': return ['content$body.inputD_2*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
    return []
  },
}
